import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Menu, X, Phone } from 'lucide-react'
import { cn } from '../../utils'
import { navigation } from '../../data'
import { Button } from '../common'

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [lastScrollPos, setLastScrollPos] = useState(0)
  const location = useLocation()

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMobileMenuOpen])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY

      if (currentScrollPos > 64) {
        if (currentScrollPos > lastScrollPos) {
          setIsScrolled(true)
        } else {
          setIsScrolled(false)
        }
      } else {
        setIsScrolled(false)
      }

      setLastScrollPos(currentScrollPos)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollPos])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const handleMobileNavClick = () => {
    scrollToTop()
    setIsMobileMenuOpen(false)
  }

  return (
    <header
      className={cn(
        'fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-md',
        'transition-transform duration-300 ease-in-out',
        isScrolled ? '-translate-y-full' : 'translate-y-0'
      )}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-12 md:h-16">
          <button
            onClick={scrollToTop}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <div className="w-10 h-10 border border-primary-500 rounded-full overflow-hidden flex items-center justify-center">
              <img src="/logo.png" alt="logo" className="w-8 h-8" />
            </div>
            <span className="font-bold text-xl transition-colors duration-300 text-gray-900">
              书香云库
            </span>
          </button>

          <nav className="hidden lg:flex items-center space-x-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href

              return (
                <div key={item.id}>
                  <Link
                    to={item.href}
                    onClick={scrollToTop}
                    className={cn(
                      'px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200',
                      isActive
                        ? 'text-primary-500 bg-primary-50'
                        : 'text-gray-600 hover:text-primary-500 hover:bg-gray-50'
                    )}
                  >
                    {item.label}
                  </Link>
                </div>
              )
            })}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            {/*  <a
              href="tel:400-888-8888"
              className="flex items-center space-x-2 text-sm font-medium transition-colors duration-300 text-gray-600"
            >
              <Phone className="w-4 h-4" />
              <span>400-888-8888</span>
            </a> */}
            {/*  <Button variant="default" size="sm">
              智能管理系统
            </Button> */}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg transition-colors duration-200 text-gray-600 hover:bg-gray-100"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <nav className="container-custom py-4">
            {navigation.map((item) => (
              <Link
                key={item.id}
                to={item.href}
                onClick={handleMobileNavClick}
                className={cn(
                  'block px-4 py-3 rounded-lg text-base font-medium transition-colors duration-200',
                  location.pathname === item.href
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-gray-600 hover:text-primary-500 hover:bg-gray-50'
                )}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-4 pt-4 border-t border-gray-100 space-y-3">
              <a
                href="tel:400-888-8888"
                className="flex items-center space-x-2 px-4 py-2 text-gray-600"
              >
                <Phone className="w-4 h-4" />
                <span>400-888-8888</span>
              </a>
              <div className="px-4">
                <Button className="w-full">免费试用</Button>
              </div>
            </div>
          </nav>
        </div>
      )}
    </header>
  )
}
